import { render, staticRenderFns } from "./PaginationNumberOfPages.vue?vue&type=template&id=73b5b5f9"
import script from "./PaginationNumberOfPages.vue?vue&type=script&lang=js"
export * from "./PaginationNumberOfPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports